import PowerMeter from './PowerMeter';

export default PowerMeter;
